import { Injectable } from '@angular/core';
import { ApplicationService } from '../../../../shared/services/application/application.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { filter, Observable, switchMap, tap } from 'rxjs';
import {
    ApplicationSubmitToPscaResponse,
    ApplicationSubmitToPscaStatus,
} from '../../models/application-submit-to-psca-response';
import { ModalComponent } from '../../../../../../shared/components/modal/modal.component';
import {
    SubmissionToPscaCompleteDialogMessage,
    SubmissionToPscaFailedValidationDialogMessage,
} from '../../../../shared/constants/submission-dialog-message';
import { CheckmarkDialogComponent } from '../../../../../../shared/components/checkmark-dialog/checkmark-dialog.component';
import { RouteConstants } from '../../../../../../core/constants/routes';
import { ApplicationUserEmailVerificationService } from '../../../../../shared/services/application-user-email-verification/application-user-email-verification.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationSubmitToPscaService {
    constructor(
        private readonly applicationUserEmailVerificationService: ApplicationUserEmailVerificationService,
        private readonly applicationService: ApplicationService,
        private readonly dialog: MatDialog,
        private readonly router: Router,
    ) {}

    submitToPsca(
        applicationId: string,
        applicationUserId: number | null,
        showSuccessDialog: boolean = true,
    ): Observable<ApplicationSubmitToPscaResponse> {
        return this.applicationUserEmailVerificationService
            .checkEmailVerification(applicationUserId)
            .pipe(
                filter((confirmed) => confirmed === true),
                switchMap(() => {
                    return this.applicationService
                        .submitToPsca(applicationId)
                        .pipe(
                            tap((response) => {
                                if (
                                    response.submissionStatus ===
                                    ApplicationSubmitToPscaStatus.Submitted
                                ) {
                                    if (showSuccessDialog) {
                                        this.openSubmissionCompleteDialog();
                                    }
                                } else if (
                                    response.submissionStatus ===
                                    ApplicationSubmitToPscaStatus.FailedValidation
                                ) {
                                    this.openFailedValidationDialog();
                                } else {
                                    throw new Error(
                                        `Unknown submission status: ${response.submissionStatus}`,
                                    );
                                }
                            }),
                        );
                }),
            );
    }

    private openSubmissionCompleteDialog(): void {
        this.dialog.open(CheckmarkDialogComponent, {
            disableClose: true,
            data: {
                title: SubmissionToPscaCompleteDialogMessage.modalTitle,
                primaryAction: {
                    title: SubmissionToPscaCompleteDialogMessage.primaryActionTitle,
                    action: this.navigateToDashboard.bind(this),
                },
            },
        });
    }

    private openFailedValidationDialog(): void {
        this.dialog.open(ModalComponent, {
            disableClose: true,
            data: {
                title: SubmissionToPscaFailedValidationDialogMessage.modalTitle,
                content: SubmissionToPscaFailedValidationDialogMessage.content,
                primaryAction: {
                    title: SubmissionToPscaFailedValidationDialogMessage.primaryActionTitle,
                    action: this.dialog.closeAll.bind(this.dialog),
                },
                isShowCancel: false,
            },
        });
    }

    private navigateToDashboard(): void {
        this.router.navigate([RouteConstants.Dashboard.getFullRoute('INDEX')]);
    }
}
